/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteRestrictionType } from "./QuoteRestrictionType";
import {
  QuoteRestrictionTypeFromJSON,
  QuoteRestrictionTypeFromJSONTyped,
  QuoteRestrictionTypeToJSON,
  QuoteRestrictionTypeToJSONTyped,
} from "./QuoteRestrictionType";

/**
 *
 * @export
 * @interface QuoteRestriction
 */
export interface QuoteRestriction {
  /**
   *
   * @type {QuoteRestrictionType}
   * @memberof QuoteRestriction
   */
  restrictionType?: QuoteRestrictionType;
  /**
   *
   * @type {string}
   * @memberof QuoteRestriction
   */
  time?: string;
  /**
   *
   * @type {number}
   * @memberof QuoteRestriction
   */
  hours?: number;
}

/**
 * Check if a given object implements the QuoteRestriction interface.
 */
export function instanceOfQuoteRestriction(
  value: object,
): value is QuoteRestriction {
  return true;
}

export function QuoteRestrictionFromJSON(json: any): QuoteRestriction {
  return QuoteRestrictionFromJSONTyped(json, false);
}

export function QuoteRestrictionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteRestriction {
  if (json == null) {
    return json;
  }
  return {
    restrictionType:
      json["restrictionType"] == null
        ? undefined
        : QuoteRestrictionTypeFromJSON(json["restrictionType"]),
    time: json["time"] == null ? undefined : json["time"],
    hours: json["hours"] == null ? undefined : json["hours"],
  };
}

export function QuoteRestrictionToJSON(json: any): QuoteRestriction {
  return QuoteRestrictionToJSONTyped(json, false);
}

export function QuoteRestrictionToJSONTyped(
  value?: QuoteRestriction | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    restrictionType: QuoteRestrictionTypeToJSON(value["restrictionType"]),
    time: value["time"],
    hours: value["hours"],
  };
}
